module.exports = __webpack_public_path__ + "static/media/Card4.05cbfb96.png";